import styled from "styled-components";

export const StatsWrapper = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 3rem 1.3rem;
  /* gap: 2.5rem; */

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 1rem;
  }

  .top-card-total {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
    }
  }

  .bottom-card-total {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;
    margin-top: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(2, 1fr);
      margin-bottom: 5rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      grid-template-columns: repeat(2, 1fr);
      margin-bottom: 5rem;
    }
  }

  .table {
    width: 100%;
    margin-top: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      margin-top: 5rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      margin-top: 5rem;
      /* padding-top: 5rem; */
    }
  }

  .table-wrapper {
    width: 100%;
  }
`;
